import { call, take, put  }  from 'redux-saga/effects';
import axios                 from 'axios';
import { 
        SET_GROUP_CONTENT,         
        SET_GROUP_LESSONS_LOADER
      }                      from '../actions';
import mockData              from '../data/mockData/mockGroupData';

const getGroupsEndpoint = 'https://www.yisumatica.org.il/flash-upload/js/outsiders/php/get_lesson_list_mygroup.php';

const addOrigin = (arr: { [key: string]: any }) => {
   for ( let i = 0; i < arr.length; i++ ) {
       arr[i].origin = 'teacherContent';
       arr[i].author = ''
   }

   return arr;
}


function* getGroupContent(): Generator<any,any,any> {
  while(true) {
    try {
     

        const userInput = yield take('GET_GROUP_CONTENT_SAGA');

        yield put(SET_GROUP_LESSONS_LOADER())

        const groupName = userInput.payload;

        if (process.env.NODE_ENV === 'development') {

              console.log('GET_GROUP_CONTENT_SAGA')

              const payload = yield addOrigin(mockData)
            
              if ( groupName === 'צבי' ) {
                yield put(SET_GROUP_CONTENT( payload ))
              }
              else {
                yield put(SET_GROUP_CONTENT([]))
              }
              
        }


        if (process.env.NODE_ENV === 'production') {

            const groups = yield call( axios.post, getGroupsEndpoint, { mygroup: groupName });

          //  console.log('groups.data    :   ',groups.data)

            if ( !!groups && !!groups.data && !!groups.data.length ) {

                const payload = yield addOrigin(groups.data);

                yield put(SET_GROUP_CONTENT( payload ))

            }

            else {
              yield put(SET_GROUP_CONTENT([]))
              console.log("can't get groups")
            }

            
        }
    }
    catch(err) {
      yield put(SET_GROUP_CONTENT([]))
      console.log('err in getGroups  :  '+err);
    }
    finally {}
  }
}


export default getGroupContent;






